import { axiosInstance,axiosFormDataInstance} from "./axiosConfig";


export const listCustomers = async (page=1,perPage,search='',$type='',isBlocked='') => {
    let url = '/customer?page='+page+'&per_page='+perPage;
    if(search !== ''){
        url = url+'&search='+search;
    }
    if($type !== '' && $type !== 'all'){
        url = url+'&type='+$type;
    }
    if(isBlocked !== '' && isBlocked !== 'all'){
        url = url+'&is_blocked='+(isBlocked=='blocked'?'1':'0');
    }
    return axiosInstance.get(url);
};

export const createCustomer = async (formData) => {
    return axiosFormDataInstance.post('/customer', formData,{
        timeout: 30000,
    });
};

export const showCustomer = async (id) => {
    return axiosInstance.get('/customer/'+id);
};

export const deleteCustomer = async (id) => {
    return axiosInstance.delete('/customer/'+id);
};

export const updateCustomer = async (id,formData) => {
    return axiosFormDataInstance.put('/customer/'+id, {formData});
};

export const updateCustomerData = async (id,allowedSimsNumber,isBlockedItem,blockReason) => {
    return axiosInstance.put('/customer/'+id, {allowed_sims_number:allowedSimsNumber,is_blocked:isBlockedItem,block_reason:blockReason});
};


export const checkCustomer = async (id,documentType,name,birthDate, type) => {
    return axiosInstance.get('/customer/check?id='+id+'&document_type='+documentType+'&name='+name+'&birth_date='+birthDate+'&type='+type);
};
